import React, { FC } from 'react';
import TableSimple from 'src/components/TableSimple';
import { CustomRenderType, TableColumnType, TableRowType } from 'src/types/table';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import translate from '@translate';
import { ProductCompletionSheetFinalProductType } from 'src/types/productCompletionSheet';
import { colors, sizes } from 'src/themes/default';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import StyledLink from 'src/components/StyledLink';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { FormErrorsType } from '../../types/global';

// export type EditKeysType = 'PRODUCT_COUNT' | 'PRODUCT_SKU' | 'ID_BILL_OF_MATERIALS';
export type EditKeysType = 'ID_BILL_OF_MATERIALS' | 'COUNT' | 'LOT';

const allColumns: TableColumnType[] = [
    {
        key: 'ID_FINAL_PRODUCT',
        label: 'finalProduct',
        customRender: true,
        disableFilter: true,
        disableSort: true,
    },
    {
        key: 'ID_BILL_OF_MATERIALS',
        label: 'billOfMaterials',
        customRender: true,
        disableFilter: true,
        disableSort: true,
    },
    {
        key: 'COUNT',
        label: 'count',
        type: 'number',
    },
    {
        key: 'LOT',
        label: 'lot',
    },
    {
        key: 'STATUS',
        label: 'status',
        type: 'select',
        selectOption: 'productCompletionSheetStatusCodes',
    },
    {
        key: 'COMPLETED_AT',
        label: 'completedAt',
        type: 'dateTime',
    },
];

type ProductsTablePropsType = {
    newProductCompletionSheet: boolean;
    data?: ProductCompletionSheetFinalProductType[];
    onChange: (value: any, error: boolean, errorKey?: string) => void;
    disableEdit?: boolean;
    editErrors: FormErrorsType;
    productsConstatns?: ConstantsCodeType[];
    billsOfMaterialConstatns?: ConstantsCodeType[];
};

const ProductsTable: FC<ProductsTablePropsType> = (props) => {
    const handleToggleRow = (row: TableRowType) => {
        if (row.ID < 0) {
            props.onChange(
                props.data?.filter((item) => item.ID != row.ID),
                false
            );
        } else {
            props.onChange(
                props.data?.map((item) => {
                    if (item.ID === row.ID) {
                        return { ...item, LINE_STATE: row.LINE_STATE === 'D' ? 'E' : 'D' };
                    }
                    return item;
                }),
                false
            );
        }
    };

    const customRender: CustomRenderType = (column, row) => {
        switch (column.key) {
            case 'ID_FINAL_PRODUCT':
                const product = props.productsConstatns?.find((item) => item.value === row.ID_FINAL_PRODUCT);
                return <StyledLink to={`/products/${product?.value}`}>{product?.label}</StyledLink>;
            case 'ID_BILL_OF_MATERIALS':
                const billOfMaterials = props.billsOfMaterialConstatns?.find(
                    (item) => item.value === Number(row.ID_BILL_OF_MATERIALS)
                );
                return (
                    <StyledLink to={`/products/bill_of_materials/${billOfMaterials?.value}`}>
                        {billOfMaterials?.label}
                    </StyledLink>
                );
        }
    };

    return (
        <TableSimple
            rowIdKey="ID"
            rows={props.data || []}
            columsLabelPrefix="productCompletionSheetDetail.finalProductsTable"
            allColumns={allColumns}
            initSort={{ column: 'ID', direction: 'ASC', createIdNumber: true }}
            rowActions={
                props.disableEdit
                    ? undefined
                    : [
                          {
                              icon: <HighlightOffIcon />,
                              label: translate('productCompletionSheetDetail.finalProductsTable.action.removeProduct'),
                              onClick: handleToggleRow,
                              style: { height: sizes.table_action_with_input_H },
                              hiddenFce: (row) => !!props.disableEdit || row.LINE_STATE !== 'E',
                          },
                          {
                              icon: <AddCircleIcon />,
                              label: translate('productCompletionSheetDetail.finalProductsTable.action.addProduct'),
                              onClick: handleToggleRow,
                              style: { height: sizes.table_action_with_input_H },
                              hiddenFce: (row) => !!props.disableEdit || row.LINE_STATE === 'E',
                          },
                      ]
            }
            disableFilter
            customRender={customRender}
            rowSxFce={(row) =>
                row.LINE_STATE === 'D'
                    ? { color: colors.text_T3, '& .MuiTableCell-root': { color: colors.text_T3 } }
                    : {}
            }
            sumCols={{ COUNT: true }}
            maxHeight={'unset'}
        />
    );
};

export default ProductsTable;
